// Page Loader with Progress
let progress = 0;
const progressBar = document.getElementById("progressBar");
const percentage = document.getElementById("percentage");
const loadingStatus = document.getElementById("loadingStatus");
const loader = document.getElementById("pageLoader");

const loadingSteps = [
    {
        percent: 20,
        message: "🔧 Initialisation des composants...",
    },
    {
        percent: 40,
        message: "🎨 Chargement des styles...",
    },
    {
        percent: 60,
        message: "📦 Préparation des données...",
    },
    {
        percent: 80,
        message: "🚀 Optimisation des ressources...",
    },
    {
        percent: 100,
        message: "✅ Prêt !",
    },
];

let currentStep = 0;

function updateProgress() {
    if (progress < 100) {
        const increment = Math.random() * 15 + 5;
        progress = Math.min(progress + increment, 100);

        progressBar.style.width = progress + "%";
        percentage.textContent = Math.floor(progress) + "%";

        for (let i = 0; i < loadingSteps.length; i++) {
            if (progress >= loadingSteps[i].percent && currentStep < i + 1) {
                currentStep = i + 1;
                loadingStatus.textContent = loadingSteps[i].message;
                break;
            }
        }

        if (progress < 100) {
            setTimeout(updateProgress, Math.random() * 200 + 100);
        } else {
            setTimeout(() => {
                loader.classList.add("hidden");
            }, 500);
        }
    }
}

setTimeout(updateProgress, 300);

window.addEventListener("load", function () {
    if (progress < 100) {
        progress = 85;
        updateProgress();
    }
});
